"use strict";

const Navigation = () => {
    const init = () => {
        $(function(){
            var $navbar = $('.js-navigation');
            if ($navbar.length > 0) {

                // hardcoded to open menu item
                $('.js-open-range-inclusion').on('click', function(e) {
                    e.preventDefault();
                    $navbar.find('.js-mega-toggle[data-mega="home-designs"]').trigger('click');
                    $navbar.find('.js-mega-menu[data-mega="home-designs"]').find('.js-tabs-tab[data-id="2"]').trigger('click');
                });

                $('.js-navigation-toggle').on('click', function() {
                    if($navbar.hasClass('open')){
                        $navbar.removeClass('open')
                    }else{
                        $navbar.addClass('open')
                    }
                });

                $navbar.find('.js-mega-toggle').on('click', function() {
                    var $mega = $navbar.find('.js-mega-menu[data-mega="'+$(this).data('mega')+'"]');
                    if($(this).hasClass('open')){
                        $navbar.find('.js-mega-toggle').removeClass('open')
                        $navbar.find('.js-mega-menu').removeClass('open')
                        $navbar.removeClass('mega-open')
                    }else{
                        $navbar.find('.js-mega-toggle').removeClass('open')
                        $navbar.find('.js-mega-menu').removeClass('open')
                        $(this).addClass('open')
                        $mega.addClass('open')
                        $navbar.addClass('mega-open')
                    }
                });

                $navbar.find('.js-mega-mobile-toggle').on('click', function() {
                    var $mega = $navbar.find('.js-mega-mobile-menu[data-mega="'+$(this).data('mega')+'"]');
                    if($(this).hasClass('open')){
                        $(this).removeClass('open')
                        $mega.removeClass('open')
                        if($navbar.find('.js-mega-mobile-menu.open').length <= 0){
                            $navbar.removeClass('mega-open')
                        }
                    }else{
                        $(this).addClass('open')
                        $mega.addClass('open')
                        $navbar.addClass('mega-open')
                    }
                });

                $('.js-nav-home-finder-toggle').on('click', function() {
                    $navbar.find('.js-mega-toggle[data-mega="home-designs"]').trigger('click');
                });
            }
        });
    };

    return {
        init: init
    };
};

export default Navigation;